import axios from 'axios';
import * as types from '../mutation-types';
import endpoints from "../endpoints";

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {
    // properties to store terminals data
    endpoint: endpoints.terminal.endpoint, // "terminal",
    terminals: [],
  },
  // -----------------------------------------------------------------
  getters: {
    // getters and computed props on the terminals data
    terminals: state => state.terminals,
    terminalByID: state => id => {
      for (const terminal of state.terminals) {
        if (terminal.eid === id) return terminal;
      }
      return undefined;
    },
  },
  // -----------------------------------------------------------------
  mutations: {
    [types.TERMINALS_LOAD](state, terminals) {
      state.terminals = JSON.parse(JSON.stringify(terminals));
    }
  },
  // -----------------------------------------------------------------
  actions: {
    fetchByIDs: (context, paginationData) => {
      const ids = paginationData.ids;
      if (typeof ids === 'undefined') {
        console.error("terminal/fetchByIDs ids is undefined");
        return
      }
      const api = context.rootGetters['global/apiUrl'] + '/' + context.state.endpoint + '/' + ids.join(',') + ',';

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          params: {
            fields: paginationData.fields
          },
          method: 'GET'
        })
          .then(resp => {
            const r = resp.data;
            if (r.success) {
              if (r.data.objects == null) r.data.objects = {}
              context.commit(types.TERMINALS_LOAD, r.data.objects);
            }
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },
    fetch: (context, paginationData) => {
      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.endpoint + "s";

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          data: paginationData,
          method: 'POST'
        })
          .then(resp => {
            const r = resp.data;
            if (r.success) {
              if (r.data.rows == null) r.data.rows = [];
              context.commit(types.TERMINALS_LOAD, r.data.rows);
            }
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },
    create: (context, userData) => {
      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.endpoint;

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          data: userData,
          method: 'POST'
        })
          .then(resp => {
            const r = resp.data;
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },
    read: (context, id) => {
      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.endpoint + "/" + id;

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          method: 'GET'
        })
          .then(resp => {
            const r = resp.data;
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },
    update: (context, data) => {
      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.endpoint + "/" + data.eid;

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          data: data,
          method: 'PUT'
        })
          .then(resp => {
            const r = resp.data;
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },
    bulkAction: (context, data) => {
      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.endpoint + "/bulkAction";

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          data,
          method: 'POST'
        })
          .then(resp => {
            const r = resp.data;
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    }
  }
};
